export default __webpack_public_path__ + "static/media/number-list-block-thumbnail-light.8fdc3c8c.svg";